import { render } from "./AppPostHeader.html?vue&type=template&id=6961bf23"
import script from "./AppPostHeader.js?vue&type=script&lang=js"
export * from "./AppPostHeader.js?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__